import { Box, Icon } from '@chakra-ui/react';
import React from 'react';

export const IconWrapper = ({ icon }) => (
  <Box
    flex="0 0 auto"
    height={6}
    width={6}
    mr={2}
    borderRadius="full"
    overflow="hidden"
    position="relative"
  >
    <Icon
      as={icon}
      height="full"
      width="auto"
      transform="translate(-50%, -50%)"
      position="absolute"
      top="50%"
      left="50%"
    />
  </Box>
);
